interface SortBarProps {
  sortValue: string;
  onSortChange: (val: string) => void;
  resultCount: number;
  viewMode: 'grid' | 'list';
  onViewModeChange: (mode: 'grid' | 'list') => void;
}

export default function SortBar({
  sortValue,
  onSortChange,
  resultCount,
  viewMode,
  onViewModeChange,
}: SortBarProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 py-3 border-b border-background-200/60">
      <p className="text-sm text-foreground-600">
        <span className="font-semibold text-foreground-900">{resultCount}</span> products found
      </p>
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-2">
          <label htmlFor="sort" className="text-sm text-foreground-600 hidden sm:inline">
            Sort by:
          </label>
          <select
            id="sort"
            value={sortValue}
            onChange={(e) => onSortChange(e.target.value)}
            className="h-9 px-3 rounded-lg bg-background-100 border border-background-200/70 text-sm text-foreground-900 focus:outline-none focus:ring-2 focus:ring-primary-400 cursor-pointer"
          >
            <option value="relevance">Relevance</option>
            <option value="price_asc">Price: Low to High</option>
            <option value="price_desc">Price: High to Low</option>
            <option value="rating">Top Rated</option>
            <option value="newest">Newest</option>
            <option value="bestselling">Best Selling</option>
          </select>
        </div>
        <div className="flex items-center rounded-lg border border-background-200/70 overflow-hidden">
          <button
            type="button"
            onClick={() => onViewModeChange('grid')}
            className={`w-9 h-9 flex items-center justify-center transition-colors ${
              viewMode === 'grid' ? 'bg-primary-500 text-background-50' : 'text-foreground-500 hover:text-foreground-800'
            }`}
            aria-label="Grid view"
          >
            <i className="ri-grid-fill" />
          </button>
          <button
            type="button"
            onClick={() => onViewModeChange('list')}
            className={`w-9 h-9 flex items-center justify-center transition-colors ${
              viewMode === 'list' ? 'bg-primary-500 text-background-50' : 'text-foreground-500 hover:text-foreground-800'
            }`}
            aria-label="List view"
          >
            <i className="ri-list-check" />
          </button>
        </div>
      </div>
    </div>
  );
}